var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-page-content',[(!_vm.isSubdivision)?[_c('v-content-info-page')]:[_c('b-card',[_c('h4',[_vm._v("Страница класса для подразделений отсутствует.")])])]],2)}
var staticRenderFns = []

export { render, staticRenderFns }